import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface BusinessIndustryProps {
  businessIndustrySelectedOption: {
    businessIndustry?: string
    businessType?: string
  }
  setBusinessIndustrySelectedOption: Dispatch<
    SetStateAction<{
      businessIndustry?: string | undefined
      businessType?: string | undefined
    }>
  >
}
export const BusinessIndustry = ({
  businessIndustrySelectedOption,
  setBusinessIndustrySelectedOption,
}: BusinessIndustryProps) => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
          What’s your business industry?
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="w-full mt-5 mx-2">
        <input
          onChange={(e) =>
            setBusinessIndustrySelectedOption({
              ...businessIndustrySelectedOption,
              businessIndustry: e.target.value,
            })
          }
          placeholder="Enter your industry"
          className={`w-full py-4 px-4 bg-transparent rounded-xl outline-none  text-black ${theme == "glassy" ? "bg-form-input bg-input bg-glass" : theme === "light" ? "bg-form-input bg-input bg-glass" : theme === "dark" ? "bg-form-input bg-input bg-glass" : " border border-[#7B68EC] bg-transparent"}`}
          type="text"
        />
      </div>
      {/* business-type */}
      <div className="mt-10">
        <div className="flex gap-1 justify-center">
          <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
            What’s your business type?
          </h2>
          <p className="pt-2 text-black"> (Optional)</p>
        </div>
        <div className="w-full mt-5 mx-2">
          <input
            onChange={(e) => {
              setBusinessIndustrySelectedOption({
                ...businessIndustrySelectedOption,
                businessType: e.target.value,
              })
            }}
            placeholder="Enter your business type"
            className={`w-full py-4 px-4 bg-transparent rounded-xl outline-none  text-black ${theme == "glassy" ? "bg-form-input bg-input bg-glass" : theme === "light" ? "bg-form-input bg-input bg-glass" : theme === "dark" ? "bg-form-input bg-input bg-glass" : " border border-[#7B68EC] bg-transparent"}`}
            type="text"
          />
        </div>
      </div>
    </div>
  )
}
